// extracted by mini-css-extract-plugin
export default {"fab":"FloatingActionButton_fab__hT03c","tooltip":"FloatingActionButton_tooltip__vphPF"};